import { render, staticRenderFns } from "./TransportVehiclePage.vue?vue&type=template&id=01efa54e&"
import script from "./TransportVehiclePage.vue?vue&type=script&lang=js&"
export * from "./TransportVehiclePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports